import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Composer, ConversationMessages } from 'features/ai-assistant/components';
import { useConversation } from 'features/ai-assistant/hooks';
import { When } from 'UI/components/atoms';
import { UIStatus } from 'UI/constants/status';

import { useConversationStyles } from './Conversation.styled';

export const Conversation = ({
  apiInstance,
  basePath,
  canSelectAIModels,
  composerPlaceholder,
  customEmptyState = null,
  initialSearchText,
  messageFullWidth = false,
  metaDataComponent,
  onMessageReplied,
  onMessagesLoaded,
  sessionId
}) => {
  const classes = useConversationStyles();
  const {
    fetchMoreMessages,
    handleClickSend,
    isLoadingMoreMessages,
    messages,
    resetScrollConfig,
    scrollConfig,
    uiStatus
  } = useConversation({
    apiInstance,
    basePath,
    sessionId,
    onMessageReplied,
    onMessagesLoaded,
    initialSearchText
  });

  return (
    <div className={classes.conversationContainer}>
      <When condition={uiStatus === UIStatus.Loading || isLoadingMoreMessages}>
        <LinearProgress />
      </When>

      <ConversationMessages
        customEmptyState={customEmptyState}
        isLoadingMoreMessages={isLoadingMoreMessages}
        messages={messages}
        messageFullWidth={messageFullWidth}
        onFetchMoreMessages={fetchMoreMessages}
        onFinishScrollDown={resetScrollConfig}
        scrollConfig={scrollConfig}
        uiStatus={uiStatus}
        metaDataComponent={metaDataComponent}
      />

      <Composer
        key={sessionId || 'new-chat'}
        canSelectAIModels={canSelectAIModels}
        onClickSend={handleClickSend}
        placeholder={composerPlaceholder}
        disabled={[UIStatus.Sending, UIStatus.Loading].includes(uiStatus)}
      />
    </div>
  );
};
